export default __webpack_public_path__ + "static/media/howknow.331f703d.svg";